import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = { class: "gfu-table__cell gfu-table__cell--short gfu-table__cell--title _flexb50 _flexb75--s _flexb60--m _flexb60--xl" }
const _hoisted_3 = {
  class: "gfu-table__cell gfu-table__cell--short _tac _flexb15 _flexb10--s gfu-table__cell--actions _screen--none _screen--s",
  "data-qa": "cart-table-quantity"
}
const _hoisted_4 = {
  class: "gfu-table__cell gfu-table__cell--short _tar _flexb50 _flexb25--s _flexb15--m _flexb15--l",
  "data-qa": "cart-table-total-row:Price"
}
const _hoisted_5 = {
  key: 0,
  class: "gfu-table__cell gfu-table__cell--short _flexb5 _screen--none _screen--s"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['gfu-table__row gfu-table__row--short', { 'gfu-table__row--total-highlighted': $props.isHighlighted }, $options.themeClass]),
    "data-qa": `cart-table-total-row:${$props.displayText}`
  }, [
    _createElementVNode("div", _hoisted_2, _toDisplayString($props.displayText) + _toDisplayString($props.useNetValue ? ' (net)' : '') + _toDisplayString($props.displayText ? ':' : ''), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_3, _toDisplayString($props.quantity), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(_ctx.$format($props.useNetValue ? $props.netValue : $props.grossValue, $props.format, $props.currencySymbol)), 1 /* TEXT */)
      ])
    ]),
    ($props.allowEditing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5))
      : _createCommentVNode("v-if", true)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}